/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  var fakeStorage = {
    get: function () {},
    key: function () {},
    getItem: function () {},
    setItem: function () {},
    removeItem: function () {},
    clear: function () {},
    length: 15,
  };

  /**
   * Модель для флага страны в localStorage
   */
  app.CountryFlag = app.Model.extend({

    localStorage: (function() {
      try {
        return new Backbone.LocalStorage('Country');
      } catch (e) {
        return fakeStorage;
      }
    })()

  });

  app.countryFlag = new app.CountryFlag();
  app.countryFlag.set('id', 1);
  app.countryFlag.fetch();
})();

}.call(window));